import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import CourseProp from '../propTypes/courseProp';
import Carousel from '../../../commonComponents/carousel/Carousel';
import RelatedCourseItem from './RelatedCourseItem';

function RelatedCourses({ t, courses }) {
  return (
    <div className="m-portlet m-portlet--rounded course-module-list-container related-list">
      <div className="m-portlet__head">
        <div className="m-portlet__head-caption">
          <div className="m-portlet__head-title">
            <h3 className="m-portlet__head-text">
              {t('academyDetails_related')}
            </h3>
          </div>
        </div>
      </div>
      <div className="m-portlet__body related-container">
        <Carousel>
          {courses.map(c => (
            <RelatedCourseItem
              key={c._id}
              className="related-course-item"
              course={c}
            />
          ))}
        </Carousel>
      </div>
    </div>
  );
}

RelatedCourses.propTypes = {
  t: PropTypes.func.isRequired,
  courses: PropTypes.arrayOf(PropTypes.shape(CourseProp.propType)).isRequired,
};

export default translate(RelatedCourses);
